import { Injectable } from '@angular/core';
import { EndpointsService, NotificationService } from "../core/services";
import { Http, Response } from '@angular/http';
import { Observable } from "rxjs/Observable";

@Injectable()
export class PaymentService {
    private static notificationService;
    constructor(private http: Http, private endpointsService: EndpointsService, private notificationService: NotificationService) {
        PaymentService.notificationService = notificationService;
    }

    public getChartData(): Observable<Response> {
        return this.http.get(this.endpointsService.GET_PAYMENT_CHART_DATA_URL)
            .catch(this.handleError);
    }

    public getPayments(sortFieldId: number, sortAsc: boolean, pageNumber: number, pageSize: number, publisherGroupIds: string): Observable<Response> {
        let url = this.getPaymentListUrl(sortFieldId, sortAsc, pageNumber, pageSize, publisherGroupIds);
        return this.http.get(url)
            .catch(this.handleError);
    }

    public updatePayment(id: number, publisherGroupId: number, revenueMonth: Date, paymentDate: Date, amount: number, status: boolean) {
        return this.http.post(this.endpointsService.UPDATE_PAYMENT_URL, { id, publisherGroupId, revenueMonth, paymentDate, amount, status })
            .catch(this.handleError);
    }

    public createPayment(publisherGroupId: number, revenueMonth: Date, paymentDate: Date, amount: number, status: boolean) {
        return this.http.post(this.endpointsService.CREATE_PAYMENT_URL, { publisherGroupId, revenueMonth, paymentDate, amount, status })
            .catch(this.handleError);
    }

    private getPaymentListUrl(sortFieldId: number, sortAsc: boolean, pageNumber: number, pageSize: number, publisherGroupIds: string): string {
        return `${this.endpointsService.GET_PAYMENT_LIST_URL}?sortFieldId=${sortFieldId}&sortAsc=${sortAsc}&pageNumber=${pageNumber}&pageSize=${pageSize}&publisherGroupIds=${publisherGroupIds}`;
    }

    private handleError(error: Response) {
        if (error.status === 400)
            PaymentService.notificationService.showError(error.json().message)
        else
            PaymentService.notificationService.showError();
        return Observable.throw(error.json().error || 'Server Error');
    }

}


// WEBPACK FOOTER //
// ./src/app/payment/payment.service.ts